import TwiceProficiencyIcon from './TwiceProficiencyIcon';

export default TwiceProficiencyIcon;
export { TwiceProficiencyIcon };
